import axios from 'axios';
import { delay } from './timingUtils';

const MAX_RETRIES = 3;

export const uploadFileToS3 = async (
    signedUrl: string,
    mimeType: string,
    fileOrBlob: File | Blob,
    cacheControl?: string,
    progressCallback?: (progress: number) => void
): Promise<void> => {
    let retries = 0;

    while (retries < MAX_RETRIES + 1) {
        try {
            const headers: { [key: string]: string } = {
                'Content-Type': mimeType,
                ...(cacheControl?.length && { 'Cache-Control': cacheControl })
            };

            await axios.put(signedUrl, fileOrBlob, {
                headers: headers,
                onUploadProgress: (progressEvent) => {
                    const percentComplete = (progressEvent.loaded / progressEvent.total) * 100;
                    if (progressCallback) progressCallback(Math.floor(percentComplete));
                }
            });

            return;
        } catch (error) {
            ++retries;
            if (retries >= MAX_RETRIES) {
                throw new Error(error as string);
            } else {
                console.warn(
                    `Failed uploading to ${signedUrl} with mime ${mimeType}. Retrying ${retries}/${MAX_RETRIES}`
                );
                await delay(2000);
            }
        }
    }
};
